import React from 'react';
import styled from 'styled-components';
import { brandColours, fontSize, minBreakpointQuery } from '../../styles';
import { Svg } from './Svg';
import barIcon from '../../images/facility-icons/bar.svg';
import bikesIcon from '../../images/facility-icons/bikes.svg';
import cocktailLoungeIcon from '../../images/facility-icons/cocktail-lounge.svg';
import experienceShowerIcon from '../../images/facility-icons/experience-shower.svg';
import fitnessClassIcon from '../../images/facility-icons/fitness-class.svg';
import foodIcon from '../../images/facility-icons/food.svg';
import footSpaIcon from '../../images/facility-icons/foot-spa.svg';
import gardenIcon from '../../images/facility-icons/garden.svg';
import golfIcon from '../../images/facility-icons/golf.svg';
import gymIcon from '../../images/facility-icons/gym.svg';
import hairDresserIcon from '../../images/facility-icons/hair-dresser.svg';
import heatedLoungersIcon from '../../images/facility-icons/heated-loungers.svg';
import hottubIcon from '../../images/facility-icons/hottub.svg';
import hydroPoolIcon from '../../images/facility-icons/hydro-pool.svg';
import rasul1Icon from '../../images/facility-icons/rasul-1.svg';
import rasul2Icon from '../../images/facility-icons/rasul-2.svg';
import rasul3Icon from '../../images/facility-icons/rasul-3.svg';
import relaxationRoomIcon from '../../images/facility-icons/relaxation-room.svg';
import resturauntIcon from '../../images/facility-icons/resturaunt.svg';
import saunaIcon from '../../images/facility-icons/sauna.svg';
import steamRoomIcon from '../../images/facility-icons/steam-room.svg';
import swimmingPoolIcon from '../../images/facility-icons/swimming-pool.svg';
import tennisIcon from '../../images/facility-icons/tennis.svg';
import yogaIcon from '../../images/facility-icons/yoga.svg';
import defaultIcon from '../../images/facility-icons/default.svg';

const StyledIconPoints = styled.ul``;

const StyledItem = styled.li`
  position: relative;
  margin-top: 12px;
  padding-left: 40px;
  line-height: 1.6;

  ${minBreakpointQuery.small`
    margin-top: 14px;
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 16px;
  `}

  &:first-child {
    margin-top: 0;
  }
`;

const StyledIcon = styled(Svg)`
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  fill: ${brandColours.primary};

  ${minBreakpointQuery.small`
    top: 2px;
  `}
`;

export const IconPoints = ({ items, ...props }) => {
  const getIcon = name => {
    let icon;

    switch (name) {
      case 'bar':
        icon = barIcon;
        break;
      case 'bikes':
        icon = bikesIcon;
        break;
      case 'cocktail-lounge':
        icon = cocktailLoungeIcon;
        break;
      case 'experience-shower':
        icon = experienceShowerIcon;
        break;
      case 'fitness-class':
        icon = fitnessClassIcon;
        break;
      case 'food':
        icon = foodIcon;
        break;
      case 'foot-spa':
        icon = footSpaIcon;
        break;
      case 'garden':
        icon = gardenIcon;
        break;
      case 'golf':
        icon = golfIcon;
        break;
      case 'gym':
        icon = gymIcon;
        break;
      case 'hair-dresser':
        icon = hairDresserIcon;
        break;
      case 'heated-loungers':
        icon = heatedLoungersIcon;
        break;
      case 'hottub':
        icon = hottubIcon;
        break;
      case 'hydro-pool':
        icon = hydroPoolIcon;
        break;
      case 'rasul-1':
        icon = rasul1Icon;
        break;
      case 'rasul-2':
        icon = rasul2Icon;
        break;
      case 'rasul-3':
        icon = rasul3Icon;
        break;
      case 'relaxation-room':
        icon = relaxationRoomIcon;
        break;
      case 'resturaunt':
        icon = resturauntIcon;
        break;
      case 'sauna':
        icon = saunaIcon;
        break;
      case 'steam-room':
        icon = steamRoomIcon;
        break;
      case 'swimming-pool':
        icon = swimmingPoolIcon;
        break;
      case 'tennis':
        icon = tennisIcon;
        break;
      case 'yoga':
        icon = yogaIcon;
        break;
      default:
        icon = defaultIcon;
    }

    return icon;
  };

  return (
    <StyledIconPoints {...props}>
      {items.map(({ icon, text }, id) => (
        <StyledItem key={id}>
          <StyledIcon image={getIcon(icon)} />
          {text}
        </StyledItem>
      ))}
    </StyledIconPoints>
  );
};
